import React from "react";
import useStyles from "./styles";

const UserFilterCheckboxIcon = () => {
  const classes = useStyles();

  return (
    <div className={classes.checkbox} />
  );
};

export default UserFilterCheckboxIcon;
